export default "__VITE_ASSET__Brjrj2xL__"